import { useTranslation } from 'react-i18next';

import { useAppState } from '../../../AppStateProvider';
import { Page } from '../../../domain/page';

import { CompanyNameView } from './CompanyNameView';
import { ContactNameView } from './ContactNameView';
import { SamLogo } from './SamLogo';
import { StyledInsightsHeading } from './styles';

export const InsightsHeading = () => {
  const { t } = useTranslation();
  const { page } = useAppState();
  const name = page === Page.Contact ? <ContactNameView /> : <CompanyNameView />;
  return (
    <StyledInsightsHeading data-automation="InsightsHeading">
      <SamLogo />
      {t('insights.heading')}&nbsp;{name}
    </StyledInsightsHeading>
  );
};
